import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "./cartSlice";
import dataSlice from "./dataSlice";
import modalSlice from "./modalSlice";

export const store = configureStore({
  reducer: {
    data: dataSlice,
    modal: modalSlice,
    cart: cartSlice,
  },
});
